const County = () =>
  import(
    /* webpackChunkName: "base-info-geo-county" */ '@/pages/base-info/geo/county/index.vue'
  )
const CreateCounty = () =>
  import(
    /* webpackChunkName: "base-info-geo-county" */ '@/pages/base-info/geo/county/create.vue'
  )
const EditCounty = () =>
  import(
    /* webpackChunkName: "base-info-geo-county" */ '@/pages/base-info/geo/county/edit.vue'
  )

export default {
  path: 'county',
  meta: {
    label: 'county',
    auth: 'county'
  },
  component: {
    name: 'County',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoGeoCounty',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: County
    },
    {
      name: 'BaseInfoCreateGeoCounty',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCounty
    },
    {
      name: 'BaseInfoEditGeoCounty',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCounty,
      props: true
    }
  ]
}
